import React from 'react';

const Branches = () => {
    return (
        <div>
            <svg width="306" height="215" viewBox="0 0 306 215" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M-10 -30.8574C-10 -35.2757 -6.41828 -38.8574 -2 -38.8574H305.549C309.967 -38.8574 313.549 -35.2757 313.549 -30.8574V230.071H-10V-30.8574Z"
                    fill="url(#paint0_linear_3254_26196)"
                />
                <path
                    d="M271.224 198.161C284.505 177.332 287.912 151.047 284.116 126.953C283.393 122.36 282.327 117.828 280.928 113.394C271.617 83.8634 247.684 60.2199 219.354 47.7544C192.332 35.8726 158.169 29.9938 132.563 48.2926C115.701 60.34 106.154 79.6489 90.7158 93.166C83.0444 99.8811 74.6444 102.067 65.5157 106.083C43.2673 115.878 24.6456 134.761 23.1138 159.659C22.1979 173.132 25.4143 186.564 32.3336 198.161H271.224Z"
                    fill="#145DA0"
                />
                <path
                    opacity="0.8"
                    d="M271.224 198.161C284.505 177.332 287.912 151.047 284.116 126.953C283.393 122.36 282.327 117.828 280.928 113.394C271.617 83.8634 247.684 60.2199 219.354 47.7544C192.332 35.8726 158.169 29.9938 132.563 48.2926C115.701 60.34 106.154 79.6489 90.7158 93.166C83.0444 99.8811 74.6444 102.067 65.5157 106.083C43.2673 115.878 24.6456 134.761 23.1138 159.659C22.1979 173.132 25.4143 186.564 32.3336 198.161H271.224Z"
                    fill="white"
                />
                <path
                    d="M31.919 195.519C46.0288 195.519 57.467 183.469 57.467 168.605C57.467 153.74 46.0288 141.69 31.919 141.69C17.8093 141.69 6.37109 153.74 6.37109 168.605C6.37109 183.469 17.8093 195.519 31.919 195.519Z"
                    fill="#145DA0"
                />
                <path
                    opacity="0.4"
                    d="M31.919 195.519C46.0288 195.519 57.467 183.469 57.467 168.605C57.467 153.74 46.0288 141.69 31.919 141.69C17.8093 141.69 6.37109 153.74 6.37109 168.605C6.37109 183.469 17.8093 195.519 31.919 195.519Z"
                    fill="white"
                />
                <path
                    d="M35.1039 183.235L31.4731 187.173L31.3323 178.458L34.3297 174.384L31.2992 176.38L31.1626 168.195H30.7693L30.7155 172.008L28.3846 170.579L30.6906 174.003L30.5664 183.215L26 181.149L30.4588 185.355L29.7219 198.375H31.9243L31.5517 189.375L35.1039 183.235Z"
                    fill="#263238"
                />
                <path
                    d="M222.391 124.924C222.391 124.924 244.205 127.081 255.263 140.602C255.263 140.602 266.942 124.936 287.923 125.259C293.049 119.074 296.313 111.561 297.335 103.593C298.356 95.6251 297.093 87.5311 293.693 80.2532C290.293 72.9753 284.895 66.813 278.129 62.4837C271.362 58.1544 263.505 55.8363 255.472 55.7993C247.44 55.7622 239.561 58.0078 232.755 62.2745C225.949 66.5412 220.495 72.6535 217.028 79.8997C213.561 87.1459 212.223 95.2279 213.171 103.205C214.119 111.182 217.314 118.725 222.383 124.957L222.391 124.924Z"
                    fill="#145DA0"
                />
                <path
                    opacity="0.4"
                    d="M222.391 124.924C222.391 124.924 244.205 127.081 255.263 140.602C255.263 140.602 266.942 124.936 287.923 125.259C293.049 119.074 296.313 111.561 297.335 103.593C298.356 95.6251 297.093 87.5311 293.693 80.2532C290.293 72.9753 284.895 66.813 278.129 62.4837C271.362 58.1544 263.505 55.8363 255.472 55.7993C247.44 55.7622 239.561 58.0078 232.755 62.2745C225.949 66.5412 220.495 72.6535 217.028 79.8997C213.561 87.1459 212.223 95.2279 213.171 103.205C214.119 111.182 217.314 118.725 222.383 124.957L222.391 124.924Z"
                    fill="white"
                />
                <path
                    d="M234.661 109.601C245.557 113.054 252.322 123.181 254.09 126.103L253.928 198.16H257.07L256.598 134.942C258.975 131.345 265.773 122.365 276.272 119.161C276.272 119.161 263.802 122.117 256.52 132.053L256.106 116.917C257.898 114.044 264.92 103.847 276.263 100.382C276.263 100.382 263.222 103.47 256.023 113.957L255.609 98.7049L255.638 98.9078C255.638 98.9078 263.003 85.6598 276.259 81.6026C276.259 81.6026 262.597 84.8401 255.535 95.9228L254.533 75.3926L254.222 104.82C247.288 94.2793 234.652 91.1577 234.652 91.1577C245.83 94.6933 252.645 105.234 254.201 107.867L254.102 123.036C247.134 112.673 234.661 109.601 234.661 109.601Z"
                    fill="#263238"
                />
                <path
                    d="M234.661 109.601C245.557 113.054 252.322 123.181 254.09 126.103L253.928 198.16H257.07L256.598 134.942C258.975 131.345 265.773 122.365 276.272 119.161C276.272 119.161 263.802 122.117 256.52 132.053L256.106 116.917C257.898 114.044 264.92 103.847 276.263 100.382C276.263 100.382 263.222 103.47 256.023 113.957L255.609 98.7049L255.638 98.9078C255.638 98.9078 263.003 85.6598 276.259 81.6026C276.259 81.6026 262.597 84.8401 255.535 95.9228L254.533 75.3926L254.222 104.82C247.288 94.2793 234.652 91.1577 234.652 91.1577C245.83 94.6933 252.645 105.234 254.201 107.867L254.102 123.036C247.134 112.673 234.661 109.601 234.661 109.601Z"
                    fill="#263238"
                />
                <path
                    d="M270.681 195.519C284.791 195.519 296.229 183.469 296.229 168.605C296.229 153.74 284.791 141.69 270.681 141.69C256.571 141.69 245.133 153.74 245.133 168.605C245.133 183.469 256.571 195.519 270.681 195.519Z"
                    fill="#145DA0"
                />
                <path
                    opacity="0.4"
                    d="M270.681 195.519C284.791 195.519 296.229 183.469 296.229 168.605C296.229 153.74 284.791 141.69 270.681 141.69C256.571 141.69 245.133 153.74 245.133 168.605C245.133 183.469 256.571 195.519 270.681 195.519Z"
                    fill="white"
                />
                <path
                    d="M273.866 183.235L270.235 187.173L270.09 178.458L273.087 174.384L270.057 176.38L269.924 168.195H269.527L269.477 172.008L267.142 170.579L269.448 174.003L269.328 183.215L264.762 181.149L269.22 185.355L268.484 198.375H270.682L270.313 189.375L273.866 183.235Z"
                    fill="#263238"
                />
                <path
                    d="M38.2535 55.6079H36.0469V198.144H38.2535V55.6079Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M40.3369 66.2935C43.1206 66.5491 45.8859 66.9763 48.6169 67.5727C52.3429 68.4587 53.6967 69.4771 58.5239 67.6058C63.3512 65.7346 69.6523 67.4071 69.6523 67.4071C69.1777 69.7084 69.1104 72.0751 69.4535 74.3996C70.0456 78.0428 70.6955 80.6717 70.6955 83.3337C70.6638 85.2129 70.4991 87.0874 70.2029 88.9434C70.2029 88.9434 68.9236 87.0763 63.4091 87.2874C57.8947 87.4985 53.941 88.6081 49.7057 88.1154C45.4705 87.6227 42.7257 86.7947 41.8397 86.7947H38.5898C38.5898 86.7947 41.3885 84.762 41.5458 83.3047C42.7133 72.3793 42.1295 72.0853 41.5458 69.266C41.2643 67.9163 41.5458 68.0819 40.9538 67.196C40.3618 66.31 38.6892 66.4094 38.6892 66.4094L40.3369 66.2935Z"
                    fill="#145DA0"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M50 70.1558L52.9063 72.7681" stroke="#263238" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M50.7266 72.0439L53.3389 74.6563"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M242.243 118.184H48.5859V198.177H242.243V118.184Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M117.035 153.941L102.922 168.054"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M105.271 168.542L101.09 172.724"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M106.878 166.937L106.125 167.69"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M147.667 161.078L140.691 168.054"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M154.808 153.941L148.66 160.085"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M144.651 166.937L138.863 172.724"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M178.545 156.193L166.684 168.054"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M180.797 153.941L180.105 154.632"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.647 166.937L164.859 172.724"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M84.539 153.941L70.4258 168.054"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M74.3893 166.937L68.6016 172.724"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M188.005 118.184H186.117V198.177H188.005V118.184Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M161.958 118.184H160.07V198.177H161.958V118.184Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M91.2863 118.184H89.3984V198.177H91.2863V118.184Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M189.422 182.35V180.462H57.4097V182.35H189.422Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M60.6333 118.184H48.5859V198.177H60.6333V118.184Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path opacity="0.55" d="M53.0425 145.061H49.4531V146.99H53.0425V145.061Z" fill="black" />
                <path opacity="0.55" d="M55.3316 147.71H51.7422V149.64H55.3316V147.71Z" fill="black" />
                <path opacity="0.22" d="M59.6402 147.71H56.0508V149.64H59.6402V147.71Z" fill="black" />
                <path opacity="0.55" d="M57.4956 145.061H53.9062V146.99H57.4956V145.061Z" fill="black" />
                <path opacity="0.22" d="M53.0425 150.348H49.4531V152.277H53.0425V150.348Z" fill="black" />
                <path opacity="0.55" d="M55.3316 153.001H51.7422V154.93H55.3316V153.001Z" fill="black" />
                <path opacity="0.22" d="M59.6402 153.001H56.0508V154.93H59.6402V153.001Z" fill="black" />
                <path opacity="0.55" d="M57.4956 150.348H53.9062V152.277H57.4956V150.348Z" fill="black" />
                <path opacity="0.22" d="M53.0425 155.638H49.4531V157.567H53.0425V155.638Z" fill="black" />
                <path opacity="0.55" d="M55.3316 158.288H51.7422V160.217H55.3316V158.288Z" fill="black" />
                <path opacity="0.22" d="M59.6402 158.288H56.0508V160.217H59.6402V158.288Z" fill="black" />
                <path opacity="0.55" d="M57.4956 155.638H53.9062V157.567H57.4956V155.638Z" fill="black" />
                <path opacity="0.22" d="M53.0425 160.925H49.4531V162.855H53.0425V160.925Z" fill="black" />
                <path opacity="0.55" d="M55.3316 163.575H51.7422V165.504H55.3316V163.575Z" fill="black" />
                <path opacity="0.22" d="M59.6402 163.575H56.0508V165.504H59.6402V163.575Z" fill="black" />
                <path opacity="0.55" d="M57.4956 160.925H53.9062V162.855H57.4956V160.925Z" fill="black" />
                <path opacity="0.22" d="M53.0425 166.212H49.4531V168.141H53.0425V166.212Z" fill="black" />
                <path opacity="0.55" d="M55.3316 168.861H51.7422V170.791H55.3316V168.861Z" fill="black" />
                <path opacity="0.22" d="M59.6402 168.861H56.0508V170.791H59.6402V168.861Z" fill="black" />
                <path opacity="0.55" d="M57.4956 166.212H53.9062V168.141H57.4956V166.212Z" fill="black" />
                <path opacity="0.22" d="M53.0425 171.499H49.4531V173.428H53.0425V171.499Z" fill="black" />
                <path opacity="0.55" d="M55.3316 174.148H51.7422V176.078H55.3316V174.148Z" fill="black" />
                <path opacity="0.22" d="M59.6402 174.148H56.0508V176.078H59.6402V174.148Z" fill="black" />
                <path opacity="0.55" d="M57.4956 171.499H53.9062V173.428H57.4956V171.499Z" fill="black" />
                <path opacity="0.22" d="M53.0425 176.786H49.4531V178.715H53.0425V176.786Z" fill="black" />
                <path opacity="0.55" d="M55.3316 179.435H51.7422V181.364H55.3316V179.435Z" fill="black" />
                <path opacity="0.22" d="M59.6402 179.435H56.0508V181.364H59.6402V179.435Z" fill="black" />
                <path opacity="0.55" d="M57.4956 176.786H53.9062V178.715H57.4956V176.786Z" fill="black" />
                <path opacity="0.22" d="M53.0425 182.072H49.4531V184.001H53.0425V182.072Z" fill="black" />
                <path opacity="0.55" d="M55.3316 184.722H51.7422V186.651H55.3316V184.722Z" fill="black" />
                <path opacity="0.22" d="M59.6402 184.722H56.0508V186.651H59.6402V184.722Z" fill="black" />
                <path opacity="0.55" d="M57.4956 182.072H53.9062V184.001H57.4956V182.072Z" fill="black" />
                <path opacity="0.22" d="M53.0425 187.359H49.4531V189.288H53.0425V187.359Z" fill="black" />
                <path opacity="0.55" d="M55.3316 190.009H51.7422V191.938H55.3316V190.009Z" fill="black" />
                <path opacity="0.22" d="M59.6402 190.009H56.0508V191.938H59.6402V190.009Z" fill="black" />
                <path opacity="0.55" d="M57.4956 187.359H53.9062V189.288H57.4956V187.359Z" fill="black" />
                <path opacity="0.22" d="M53.0425 192.646H49.4531V194.575H53.0425V192.646Z" fill="black" />
                <path opacity="0.55" d="M55.3316 195.295H51.7422V197.225H55.3316V195.295Z" fill="black" />
                <path opacity="0.22" d="M59.6402 195.295H56.0508V197.225H59.6402V195.295Z" fill="black" />
                <path opacity="0.55" d="M57.4956 192.646H53.9062V194.575H57.4956V192.646Z" fill="black" />
                <path
                    d="M60.6333 118.184H48.5859V143.769H60.6333V118.184Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M242.243 118.184H48.5859V140.834H242.243V118.184Z"
                    fill="#145DA0"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    opacity="0.4"
                    d="M242.243 118.184H48.5859V140.834H242.243V118.184Z"
                    fill="black"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M242.243 118.184H48.5859V131.249H242.243V118.184Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M242.243 118.184H48.5859V140.834H242.243V118.184Z"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M135.168 118.184H123.121V198.177H135.168V118.184Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path opacity="0.55" d="M127.75 145.061H124.16V146.99H127.75V145.061Z" fill="black" />
                <path opacity="0.55" d="M130.039 147.71H126.449V149.64H130.039V147.71Z" fill="black" />
                <path opacity="0.22" d="M134.347 147.71H130.758V149.64H134.347V147.71Z" fill="black" />
                <path opacity="0.55" d="M132.207 145.061H128.617V146.99H132.207V145.061Z" fill="black" />
                <path opacity="0.22" d="M127.75 150.348H124.16V152.277H127.75V150.348Z" fill="black" />
                <path opacity="0.55" d="M130.039 153.001H126.449V154.93H130.039V153.001Z" fill="black" />
                <path opacity="0.22" d="M134.347 153.001H130.758V154.93H134.347V153.001Z" fill="black" />
                <path opacity="0.55" d="M132.207 150.348H128.617V152.277H132.207V150.348Z" fill="black" />
                <path opacity="0.22" d="M127.75 155.638H124.16V157.567H127.75V155.638Z" fill="black" />
                <path opacity="0.55" d="M130.039 158.288H126.449V160.217H130.039V158.288Z" fill="black" />
                <path opacity="0.22" d="M134.347 158.288H130.758V160.217H134.347V158.288Z" fill="black" />
                <path opacity="0.55" d="M132.207 155.638H128.617V157.567H132.207V155.638Z" fill="black" />
                <path opacity="0.22" d="M127.75 160.925H124.16V162.855H127.75V160.925Z" fill="black" />
                <path opacity="0.55" d="M130.039 163.575H126.449V165.504H130.039V163.575Z" fill="black" />
                <path opacity="0.22" d="M134.347 163.575H130.758V165.504H134.347V163.575Z" fill="black" />
                <path opacity="0.55" d="M132.207 160.925H128.617V162.855H132.207V160.925Z" fill="black" />
                <path opacity="0.22" d="M127.75 166.212H124.16V168.141H127.75V166.212Z" fill="black" />
                <path opacity="0.55" d="M130.039 168.861H126.449V170.791H130.039V168.861Z" fill="black" />
                <path opacity="0.22" d="M134.347 168.861H130.758V170.791H134.347V168.861Z" fill="black" />
                <path opacity="0.55" d="M132.207 166.212H128.617V168.141H132.207V166.212Z" fill="black" />
                <path opacity="0.22" d="M127.75 171.499H124.16V173.428H127.75V171.499Z" fill="black" />
                <path opacity="0.55" d="M130.039 174.148H126.449V176.078H130.039V174.148Z" fill="black" />
                <path opacity="0.22" d="M134.347 174.148H130.758V176.078H134.347V174.148Z" fill="black" />
                <path opacity="0.55" d="M132.207 171.499H128.617V173.428H132.207V171.499Z" fill="black" />
                <path opacity="0.22" d="M127.75 176.786H124.16V178.715H127.75V176.786Z" fill="black" />
                <path opacity="0.55" d="M130.039 179.435H126.449V181.364H130.039V179.435Z" fill="black" />
                <path opacity="0.22" d="M134.347 179.435H130.758V181.364H134.347V179.435Z" fill="black" />
                <path opacity="0.55" d="M132.207 176.786H128.617V178.715H132.207V176.786Z" fill="black" />
                <path opacity="0.22" d="M127.75 182.072H124.16V184.001H127.75V182.072Z" fill="black" />
                <path opacity="0.55" d="M130.039 184.722H126.449V186.651H130.039V184.722Z" fill="black" />
                <path opacity="0.22" d="M134.347 184.722H130.758V186.651H134.347V184.722Z" fill="black" />
                <path opacity="0.55" d="M132.207 182.072H128.617V184.001H132.207V182.072Z" fill="black" />
                <path opacity="0.22" d="M127.75 187.359H124.16V189.288H127.75V187.359Z" fill="black" />
                <path opacity="0.55" d="M130.039 190.009H126.449V191.938H130.039V190.009Z" fill="black" />
                <path opacity="0.22" d="M134.347 190.009H130.758V191.938H134.347V190.009Z" fill="black" />
                <path opacity="0.55" d="M132.207 187.359H128.617V189.288H132.207V187.359Z" fill="black" />
                <path opacity="0.22" d="M127.75 192.646H124.16V194.575H127.75V192.646Z" fill="black" />
                <path opacity="0.55" d="M130.039 195.295H126.449V197.225H130.039V195.295Z" fill="black" />
                <path opacity="0.22" d="M134.347 195.295H130.758V197.225H134.347V195.295Z" fill="black" />
                <path opacity="0.55" d="M132.207 192.646H128.617V194.575H132.207V192.646Z" fill="black" />
                <path
                    d="M135.168 118.184H123.121V143.769H135.168V118.184Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M230.756 146.418H185.883V198.181H230.756V146.418Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M228.797 148.224H187.844V196.368H228.797V148.224Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M209.896 165.566H208.973V177.584H209.896V165.566Z"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M207.427 165.566H206.504V177.584H207.427V165.566Z"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M226.173 152.508H211.352V191.627H226.173V152.508Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M205.145 152.508H190.324V191.627H205.145V152.508Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M208.195 148.567V196.422" stroke="#263238" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M242.243 118.184H230.195V198.177H242.243V118.184Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path opacity="0.55" d="M234.921 145.061H231.332V146.99H234.921V145.061Z" fill="black" />
                <path opacity="0.55" d="M237.21 147.71H233.621V149.64H237.21V147.71Z" fill="black" />
                <path opacity="0.22" d="M241.519 147.71H237.93V149.64H241.519V147.71Z" fill="black" />
                <path opacity="0.55" d="M239.378 145.061H235.789V146.99H239.378V145.061Z" fill="black" />
                <path opacity="0.22" d="M234.921 150.348H231.332V152.277H234.921V150.348Z" fill="black" />
                <path opacity="0.55" d="M237.21 153.001H233.621V154.93H237.21V153.001Z" fill="black" />
                <path opacity="0.22" d="M241.519 153.001H237.93V154.93H241.519V153.001Z" fill="black" />
                <path opacity="0.55" d="M239.378 150.348H235.789V152.277H239.378V150.348Z" fill="black" />
                <path opacity="0.22" d="M234.921 155.638H231.332V157.567H234.921V155.638Z" fill="black" />
                <path opacity="0.55" d="M237.21 158.288H233.621V160.217H237.21V158.288Z" fill="black" />
                <path opacity="0.22" d="M241.519 158.288H237.93V160.217H241.519V158.288Z" fill="black" />
                <path opacity="0.55" d="M239.378 155.638H235.789V157.567H239.378V155.638Z" fill="black" />
                <path opacity="0.22" d="M234.921 160.925H231.332V162.855H234.921V160.925Z" fill="black" />
                <path opacity="0.55" d="M237.21 163.575H233.621V165.504H237.21V163.575Z" fill="black" />
                <path opacity="0.22" d="M241.519 163.575H237.93V165.504H241.519V163.575Z" fill="black" />
                <path opacity="0.55" d="M239.378 160.925H235.789V162.855H239.378V160.925Z" fill="black" />
                <path opacity="0.22" d="M234.921 166.212H231.332V168.141H234.921V166.212Z" fill="black" />
                <path opacity="0.55" d="M237.21 168.861H233.621V170.791H237.21V168.861Z" fill="black" />
                <path opacity="0.22" d="M241.519 168.861H237.93V170.791H241.519V168.861Z" fill="black" />
                <path opacity="0.55" d="M239.378 166.212H235.789V168.141H239.378V166.212Z" fill="black" />
                <path opacity="0.22" d="M234.921 171.499H231.332V173.428H234.921V171.499Z" fill="black" />
                <path opacity="0.55" d="M237.21 174.148H233.621V176.078H237.21V174.148Z" fill="black" />
                <path opacity="0.22" d="M241.519 174.148H237.93V176.078H241.519V174.148Z" fill="black" />
                <path opacity="0.55" d="M239.378 171.499H235.789V173.428H239.378V171.499Z" fill="black" />
                <path opacity="0.22" d="M234.921 176.786H231.332V178.715H234.921V176.786Z" fill="black" />
                <path opacity="0.55" d="M237.21 179.435H233.621V181.364H237.21V179.435Z" fill="black" />
                <path opacity="0.22" d="M241.519 179.435H237.93V181.364H241.519V179.435Z" fill="black" />
                <path opacity="0.55" d="M239.378 176.786H235.789V178.715H239.378V176.786Z" fill="black" />
                <path opacity="0.22" d="M234.921 182.072H231.332V184.001H234.921V182.072Z" fill="black" />
                <path opacity="0.55" d="M237.21 184.722H233.621V186.651H237.21V184.722Z" fill="black" />
                <path opacity="0.22" d="M241.519 184.722H237.93V186.651H241.519V184.722Z" fill="black" />
                <path opacity="0.55" d="M239.378 182.072H235.789V184.001H239.378V182.072Z" fill="black" />
                <path opacity="0.22" d="M234.921 187.359H231.332V189.288H234.921V187.359Z" fill="black" />
                <path opacity="0.55" d="M237.21 190.009H233.621V191.938H237.21V190.009Z" fill="black" />
                <path opacity="0.22" d="M241.519 190.009H237.93V191.938H241.519V190.009Z" fill="black" />
                <path opacity="0.55" d="M239.378 187.359H235.789V189.288H239.378V187.359Z" fill="black" />
                <path opacity="0.22" d="M234.921 192.646H231.332V194.575H234.921V192.646Z" fill="black" />
                <path opacity="0.55" d="M237.21 195.295H233.621V197.225H237.21V195.295Z" fill="black" />
                <path opacity="0.22" d="M241.519 195.295H237.93V197.225H241.519V195.295Z" fill="black" />
                <path opacity="0.55" d="M239.378 192.646H235.789V194.575H239.378V192.646Z" fill="black" />
                <path
                    d="M242.243 118.184H230.195V143.769H242.243V118.184Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M45.4492 98.0967V126.808H122.412V140.888H243.503V126.808V98.0967H45.4492Z"
                    fill="#145DA0"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M243.501 98.0967H45.5469V102.295H243.501V98.0967Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M243.501 97.6245H45.5469V101.822H243.501V97.6245Z"
                    fill="white"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15.6133 198.177H294.533" stroke="#263238" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.6133 201.427H294.533" stroke="#263238" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M54.4746 168.911H39.4961V198.197H54.4746V168.911Z"
                    fill="#145DA0"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M54.4746 191.002H39.4961V198.194H54.4746V191.002Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M50.7572 169.959H42.7422V173.967H50.7572V169.959Z"
                    fill="#145DA0"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M50.0899 171.201H43.793V173.395H50.0899V171.201Z"
                    fill="#263238"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M55.4163 168.046H38.7031V169.669H55.4163V168.046Z"
                    fill="#145DA0"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M46.159 166.282L38.707 168.034H55.4119L47.5873 166.282C47.1173 166.175 46.629 166.175 46.159 166.282Z"
                    fill="#145DA0"
                    stroke="#263238"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M48.0839 179.688H45.6992V183.315H48.0839V179.688Z"
                    fill="white"
                    stroke="#263238"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_3254_26196"
                        x1="-10"
                        y1="95.6069"
                        x2="313.549"
                        y2="95.6069"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#457FCA" />
                        <stop offset="1" stopColor="#5691C8" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    );
};

export default Branches;
